import afterIntercomHasLoaded from 'root/utils/afterIntercomHasLoaded';

export default class LightboxUI {
    #bodyEl: HTMLElement;
    readonly #lightboxEl: HTMLElement;

    constructor() {
        this.#bodyEl = document.body;
        this.#lightboxEl = this.#createLightboxEl();
    }

    clickHandler() {
        this.#show();
        this.#addClosingButton();
        this.#resetLightboxContent();
    }

    get getLightboxEl() {
        return this.#lightboxEl;
    }

    #resetLightboxContent() {
        const isCloseBtn =
            (this.#lightboxEl.firstChild as HTMLElement | undefined)?.getAttribute(
                'data-button'
            ) === 'close';
        while (isCloseBtn && this.#lightboxEl.children.length > 1) {
            if (this.#lightboxEl.lastChild) {
                this.#lightboxEl.removeChild(this.#lightboxEl.lastChild);
            }
        }
    }

    #createLightboxEl() {
        const lightboxEl = document.querySelector<HTMLElement>('.js-lightbox-wrapper');
        if (lightboxEl) return lightboxEl; // this is to prevent creating multiple lightbox elements

        const lightboxElWrapper = document.createElement('div');
        lightboxElWrapper.classList.add(
            'js-lightbox-wrapper',
            'js-leadform-lightbox-wrapper',
            'js-leadform-lightbox-wrapper__background-color--darkest'
        );
        return this.#bodyEl.insertBefore(lightboxElWrapper, this.#bodyEl.firstChild);
    }

    #addClosingButton() {
        const closeBtn = document.createElement('div');
        closeBtn.className = 'js-close-btn gb-button__close gb-button__close--dark';
        closeBtn.setAttribute('data-button', 'close');
        this.#lightboxEl.insertBefore(closeBtn, this.#lightboxEl.firstElementChild);
        document.addEventListener('click', this.#hide.bind(this));
    }

    #show() {
        this.#bodyEl.classList.add('js-show-lightbox');
        this.#lightboxEl.style.display = 'block';
        afterIntercomHasLoaded(this.#toggleIntercomDisplay);
    }

    #hide(event: Event) {
        const target = event.target as HTMLElement;
        if (target.dataset.button === 'close') {
            this.#bodyEl.classList.remove('js-show-lightbox');
            this.#lightboxEl.style.display = 'none';
            const lightboxClosed = new CustomEvent('lightboxClosed');
            document.body.dispatchEvent(lightboxClosed);
            afterIntercomHasLoaded(() => this.#toggleIntercomDisplay(false));
        }
    }

    #toggleIntercomDisplay(hide = true) {
        const intercom = document.querySelector<HTMLElement>(
            '.intercom-lightweight-app, .intercom-app, #intercom-container'
        );
        const toggle = hide ? 'none' : 'block';
        intercom && (intercom.style.display = toggle);
    }
}
